import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { TableHeader } from 'src/app/models/tableheader.model';
export class OrderByTableHeader {
  column: string = '';
  orientation: string = '';
}
@Component({
  selector: 'app-table-header',
  templateUrl: './table-header.component.html',
  styleUrls: ['./table-header.component.scss'],
})
export class TableHeaderComponent implements OnInit {
  @Input() tableHeader!: TableHeader[];
  @Input() orderByColumnDefault!: TableHeader;
  @Input() isCheckboxColumnVisible?: boolean = false;
  @Input() isStickyEnabled?: boolean = true;
  @Input() isCheckboxChecked: boolean = false;
  @Input() isDisabled?: boolean = false;
  @Output() checkboxChanged: EventEmitter<MatCheckboxChange> =
    new EventEmitter<MatCheckboxChange>();
  @Output() orderByChange: EventEmitter<OrderByTableHeader> =
    new EventEmitter<OrderByTableHeader>();
  @ViewChild('tableHeaderElement') tableHeaderElement!: ElementRef;
  isTableHeaderSticky: boolean = false;
  tableHeaderPosition: number = 0;

  orderByColumn: string = '';
  orderByOrientation: string = '';
  @Input() orderByOrientationDefault: string = 'ASC';

  @HostListener('window:scroll', ['$event'])
  handleScroll(): void {
    if (this.isStickyEnabled) {
      this.calculateTableHeaderPosition();
      const windowScroll = window.pageYOffset;
      this.isTableHeaderSticky = false;

      if (windowScroll >= this.tableHeaderPosition) {
        this.isTableHeaderSticky = true;
      }
    }
  }

  ngOnInit(): void {
    this.isCheckboxChecked = false;
    this.isTableHeaderSticky = false;
    if (this.orderByColumnDefault.id)
      this.orderByColumn = this.orderByColumnDefault.id;
    this.orderByOrientation = this.orderByOrientationDefault;
  }

  calculateTableHeaderPosition(): void {
    this.tableHeaderPosition =
      this.tableHeaderElement?.nativeElement.offsetTop -
      this.tableHeaderElement?.nativeElement.offsetHeight -
      32;
  }

  orderBy(itemTH: any): void {
    if (!itemTH.isOrderByVisible) return;
    let column = itemTH.id;

    this.orderByColumn = column;
    if (this.orderByOrientation == 'ASC') {
      this.orderByOrientation = 'DES';
    } else if (this.orderByOrientation == 'DES') {
      this.orderByOrientation = 'ASC';
    }

    this.orderByChange.emit({
      column: this.orderByColumn,
      orientation: this.orderByOrientation,
    });
  }

  toggleCheckboxChanged(e: MatCheckboxChange): void {
    this.checkboxChanged.emit(e);
  }
}
